<div class="container shadow-lg">
  <div class="row">
    <div class="col-md-4 borderColor mt-5">
      <img
        class="w-100 rounded"
        [src]="imgPrefix + movieDetials?.poster_path"
        alt=""
      />
      <a
        [href]="videoPrefix + play"
        target="_blank"
        class="btn btn-info mt-4 float-right"
        >watch Trailer <i class="fas fa-video"></i
      ></a>
    </div>

    <div class="col-md-8 py-5">
      <table class="table table-bordered text-white">
        <thead>
          <tr>
            <th scope="col" colspan="2" class="text-center">
              {{ movieDetials?.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">language</th>
            <td>{{ movieDetials?.original_language }}</td>
          </tr>
          <tr>
            <th scope="row">Category</th>
            <td>{{ x }}</td>
          </tr>
          <tr>
            <th scope="row">country</th>
            <td>{{ y }}</td>
          </tr>
          <tr>
            <th scope="row">vote rate</th>
            <td>{{ movieDetials?.vote_average }}</td>
          </tr>
          <tr>
            <th scope="row">count rate</th>
            <td>{{ movieDetials?.vote_count }}</td>
          </tr>
          <tr>
            <th scope="row">release date</th>
            <td>{{ movieDetials?.release_date }}</td>
          </tr>
          <tr>
            <th scope="row">overview</th>
            <td>{{ movieDetials?.overview }}</td>
          </tr>
        </tbody>
      </table>
      <div class="py-3">
        <!-- <h3 class="text-white p-3 position-relative">Cast</h3> -->

        <div
          class="rounded-circle avat d-inline-block ml-3"
          *ngFor="let photo of allActor"
        >
          <div class="position-relative posterr overflow-hidden">
            <img
              [routerLink]="['/peopledetails', photo?.id]"
              [src]="imgPrefix + photo?.profile_path"
              class="avat rounded-circle mt-1"
              alt="actor"
            />
            <div
              class="
                layer
                rounded-circle
                position-absolute
                d-flex
                justify-content-center
                align-items-center             
              "
            >
              <h6 class="text-wight">more info..</h6>
            </div>
          </div>
          <h6 style="font-size: 10px" class="text-center">{{ photo.name }}</h6>
        </div>
      </div>
      <br />
    </div>
  </div>
</div>
